<template>
  <div>
    <CRow class="profileView">
      <CCol lg="4" class="text-gray">Main Speciality</CCol>
      <CCol lg="8" class="text-black">{{ mainSpeciality  }}</CCol>
    </CRow>
    <CRow class="profileView">
      <CCol lg="4" class="text-gray">Years In Speciality</CCol>
      <CCol lg="8" class="text-black">{{ mainSpecialityExperience }}</CCol>
    </CRow>
    <CRow class="profileView">
      <CCol lg="4" class="text-gray">Other Speciality Areas</CCol>
      <CCol lg="8" class="text-black">{{ otherSpecialities }}</CCol>
    </CRow>
    <CRow v-if="!isAHP" class="profileView">
      <CCol lg="4" class="text-gray"> Special Interest</CCol>
      <CCol lg="8" class="text-black">{{ specialInterest }}</CCol>
    </CRow>
    <CRow class="profileView">
      <CCol lg="4" class="text-gray">Suitable For</CCol>
      <CCol lg="8" class="text-black">{{ pqrLevels }}</CCol>
    </CRow>
    <CRow class="profileView" v-if="isFirstQualification">
      <CCol lg="4" class="text-gray">First Qualification</CCol>
      <CCol lg="8" class="text-black">
        {{ firstQualificationName }}
      </CCol>
    </CRow>
    <CRow class="profileView" v-if="isFirstQualification">
      <CCol lg="4" class="text-gray">Year & Country Obtained</CCol>
      <CCol lg="8" class="text-black">
        {{ firstQualificationYear }} & {{ firstQualificationCountry }}
      </CCol>
    </CRow>
    <CRow class="profileView">
      <CCol lg="4" class="text-gray">Highest Qualification</CCol>
      <CCol lg="8" class="text-black">
        {{
          candidate.highest_qualification_acronym
            ? candidate.highest_qualification_acronym
            : candidate.highest_qualification_name
        }}
      </CCol>
    </CRow>
    <CRow class="profileView">
      <CCol lg="4" class="text-gray">Year & Country Obtained</CCol>
      <CCol lg="8" class="text-black">
        {{ highestQualificationYear }} & {{ highestQualificationCountry }}
      </CCol>
    </CRow>
    <CRow class="profileView">
      <CCol lg="4" class="text-gray">Non Medical Qualifications</CCol>
      <CCol lg="8" class="text-black">{{ nonMedicalQuals }}</CCol>
    </CRow>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: {
    candidate: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapGetters([
      "getCandidateSpecialInterest",
      "getCandidateNonMedicalQuals"
    ]),
    isNurse() {
      return this.candidate?.candidate_type_id === 44
        ? true
        : false
    },
    isAHP() {
      return this.candidate?.candidate_type_id === 46
        ? true
        : false
    },
    type() {
      return this.candidate?.candidate_type?.candidate_type || "--";
    },
    pqrLevels() {
      if (
        Array.isArray(this.candidate.pqr_levels) &&
        this.candidate?.pqr_levels?.length
      ) {
        const pqr = this.candidate?.pqr_levels.filter(({ potential }) => !potential) || [];
        if(pqr.length){
          const pqr_levels = pqr[0];
          const pqr_level = this.isAHP
            ? pqr_levels?.pqr_ahp_detail?.speciality?.speciality
            : pqr_levels?.working_candidate_level;
          const country_code = this.isAHP 
            ? pqr_levels?.pqr_ahp_detail?.pqr_header?.country?.country_code
            :pqr_levels?.pqr_detail?.pqr_header?.country?.country_code
          return pqr_level && country_code ? `${pqr_level}(${country_code})`:pqr_level
        }
      }
      return this.candidate.level_name || "--";
    },
    highestQualification() {
      let highestQualification = null;
      this.candidate.qualifications?.length &&
        this.candidate.qualifications.some((e) => {
          if (e.main) {
            highestQualification = e;
            return true;
          }
          return false;
        });
      return highestQualification;
    },
    highestQualificationCountry() {
      return this.highestQualification?.country_name || null;
    },
    highestQualificationYear() {
      return this.highestQualification?.year_awarded;
    },
    mainSpeciality() {
      return _(this.getCandidateSpecialInterest)
        .filter((speciality) => {
          return speciality.main == true
        })
        .map((speciality)=> {
          if(this.isNurse && speciality?.sub_speciality)
            return `${speciality.speciality?.speciality} - ${speciality.sub_speciality?.sub_speciality}`
          return speciality.speciality?.speciality
        })
        .value()
        .toString() || this.candidate?.speciality?.speciality || "--"
    },
    mainSpecialityExperience() {
      return _(this.getCandidateSpecialInterest)
        .filter((speciality) => {
          return speciality.main == true
        })
        .map((speciality)=> {
          return speciality.experience_in_years
        })
        .value()
        .toString() || "--"
    },
    otherSpecialities() {
      return _(this.getCandidateSpecialInterest)
        .filter((speciality) => {
          return speciality.main != true && !speciality.other_special_interest && !speciality.special_interest
        })
        .map((speciality) => {
          return speciality.speciality
            ? this.isNurse ? `${speciality.speciality?.speciality} ${speciality?.sub_speciality?.sub_speciality ? '-'+speciality?.sub_speciality?.sub_speciality : ''}`: speciality.speciality?.speciality
            : speciality?.other_speciality
        })
        .value()
        .join(', ') || "--"
    },
    specialInterest() {
      return _(this.getCandidateSpecialInterest)
        .filter((speciality) => {
          return speciality.other_special_interest || speciality.special_interest
        })
        .map((speciality) => {
          return !speciality.other_special_interest
            ? speciality.special_interest?.special_interest
            : 'Other - ' + speciality.other_special_interest
        })
        .value()
        .join(', ') || "--"
    },
    firstQualification() {
      let firstQualification = null;
      this.candidate.qualifications?.length &&
        this.candidate.qualifications.some((e) => {
          if (!e.main) {
            firstQualification = e;
            return true;
          }
          return false;
        });
      return firstQualification;
    },
    isFirstQualification() {
      return _(this.candidate.qualifications).filter((qual) => {
          return qual.main != true
        })
        .value().length ? true : false
    },
    firstQualificationName() {
      return this.firstQualification.qualification.qualification || null
    },
    firstQualificationCountry() {
      return this.firstQualification.country_name || null
    },
    firstQualificationYear() {
      return this.firstQualification.year_awarded || null
    },
    nonMedicalQuals() {
      return _(this.getCandidateNonMedicalQuals)
        .map((qualification) => {
          return qualification.non_medical_qual?.name
            ? qualification.non_medical_qual?.name
            : 'Other - ' + qualification.others_name
        })
        .value()
        .join(', ') || "--" 
    }
  } 
}
</script>